import { Dialog, DialogContent } from '@mui/material';

interface ResourceDocumentPreviewProps {
  open: boolean;
  onClose: () => void;
  documentUrl?: string;
}

export function ResourceDocumentPreview({ open, onClose, documentUrl }: ResourceDocumentPreviewProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='md'
      fullWidth
      slotProps={{
        paper: {
          sx: { height: '80vh' },
        },
      }}
    >
      <DialogContent sx={{ padding: 0, height: '100%' }}>
        {documentUrl && (
          <iframe
            src={documentUrl}
            style={{ width: '100%', height: '100%', border: 'none' }}
            title='Resource Preview'
          />
        )}
      </DialogContent>
    </Dialog>
  );
}

export default ResourceDocumentPreview;
